// extracted by mini-css-extract-plugin
module.exports = {"fallingBills":"bills_fallingBills__3g50S","snowflakes-fall":"bills_snowflakes-fall__xuDlz","snowflakes-shake":"bills_snowflakes-shake__3jSYD"};